import { useEffect } from "react";
import { useAuthDispatchContext } from '/src/features/auth/context/authContext';
import { useNavigate } from "react-router-dom";
import storage from "./utils/storage";
import urlWithRoutingCompany from "./utils/urlWithRoutingCompany";
const Genesys = () => {

    const dispatch = useAuthDispatchContext();
    const navigate = useNavigate();

    const authorizedUrl = ['*'];
    useEffect(() => {
        const handleMessage = (event) => {
            if(authorizedUrl.includes(event.origin) == false) return;
            const message = event.data;
      
            const { token, user, company, permissions, refresh_token } = message;
    
            dispatch({type : 'loginSuccess', payload : {refresh_token, token, user}});
            
            storage('local').set('token', token);
            storage('local').set('refresh_token', refresh_token);
            storage('local').set('user', user);
            storage('session').set('company', company);
            storage('session').set('permissions', permissions);

            navigate(urlWithRoutingCompany('home'))
          };
      
          window.addEventListener('message', handleMessage);
      
          return () => {
            window.removeEventListener('message', handleMessage);
          };
    }, [dispatch, navigate]);
    return <></>;
}

export default Genesys;